import { configAPI } from '../../services/api';

// 定义动作类型
export const SHOW_NOTIFICATION = 'SHOW_NOTIFICATION';
export const HIDE_NOTIFICATION = 'HIDE_NOTIFICATION';
export const SET_LANGUAGES = 'SET_LANGUAGES';
export const SET_STATUSES = 'SET_STATUSES';

// 显示通知
export const showNotification = (message, type = 'info') => {
  return {
    type: SHOW_NOTIFICATION,
    payload: {
      message,
      type
    }
  };
};

// 隐藏通知
export const hideNotification = () => {
  return {
    type: HIDE_NOTIFICATION
  };
};

// 获取支持的翻译语种
export const fetchLanguages = () => {
  return async (dispatch) => {
    try {
      const response = await configAPI.getLanguages();
      
      dispatch({
        type: SET_LANGUAGES,
        payload: response.data.languages
      });
      
      return response.data.languages;
    } catch (error) {
      console.error('获取语种列表失败:', error);
      dispatch(showNotification('获取语种列表失败', 'error'));
      return [];
    }
  };
};

// 获取任务状态列表
export const fetchStatuses = () => {
  return async (dispatch) => {
    try {
      const response = await configAPI.getStatuses();
      
      dispatch({
        type: SET_STATUSES,
        payload: response.data.statuses
      });
      
      return response.data.statuses;
    } catch (error) {
      console.error('获取状态列表失败:', error);
      dispatch(showNotification('获取状态列表失败', 'error'));
      return [];
    }
  };
}; 